// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__V_bWe","selects":"Documents_selects__3DhrK"};